/**
 * What: Single owner of the IndexTable small-screen collapse rule for the Shopify app.
 * Transport / data-flow: Pure Polaris breakpoint read; no data fetching or state.
 *
 */
import { useBreakpoints } from '@shopify/polaris'

/**
 * Polaris index-table best practice: collapse to the condensed list only below the
 * `breakpoints-sm` value (490px) — `condensed={useBreakpoints().smDown}`. Every
 * IndexTable in the app consumes this hook instead of choosing its own breakpoint.
 */
export function useIndexTableCondensed(): boolean {
  return useBreakpoints().smDown
}
